import { useNavigate } from 'react-router';

import { ProjectAbstract } from '@/domain/project/entities/project.entity';
import {
  selectIsFetchingProjectsTour,
  selectProjectTourItems,
} from '@/domain/project-tour/project-tour.selectors';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { ProjectsPageList } from '@/ui/pages/app/components/projects-page/ProjectsPageList';
import { ProjectsPageTitleAndCreateButton } from '@/ui/pages/app/components/projects-page/ProjectsPageTitleAndCreateButton';

import { ButtonModalCreateProjectTour } from './components/ButtonModalCreateProjectTour';

export function ProjectsTour() {
  const projectItems: ProjectAbstract[] = useAppSelector(
    selectProjectTourItems,
  );
  const isFetchingProjects = useAppSelector(selectIsFetchingProjectsTour);
  const isProjectItemsEmpty = projectItems.length === 0;

  const navigate = useNavigate();

  const onClickProject = (projectId: number) => {
    navigate(`/app/projects/tour/${projectId}`);
  };

  return (
    <>
      <ProjectsPageTitleAndCreateButton
        title={translate('ProjectsTour.my-tours')}
        createButton={<ButtonModalCreateProjectTour />}
        showCreateButton={isProjectItemsEmpty === false}
      />
      <ProjectsPageList
        projectItems={projectItems}
        isFetchingProjects={isFetchingProjects}
        onClickProject={onClickProject}
        noProjectMessage={translate('ProjectsTour.no-project-message')}
        createButton={<ButtonModalCreateProjectTour />}
      />
    </>
  );
}
